import React, { Component } from 'react'
import './Result.css'

export class Result extends Component {
  getSum() {
    let sum = 0

    if (!this.props.count) {
      return 0
    } else {
      for (const a in this.props.count) {
        sum += this.props.count[a].count
      }
    }
    return sum
  }

  getPct(answerId) {
    let pct = 0
    const sum = this.getSum()

    if (!this.props.count) return 0
    if (this.props.count[answerId]) {
      pct = sum > 0 ? (this.props.count[answerId].count / sum) * 100 : 0
    }

    return pct
  }

  getPeopleCount() {
    const count = this.getSum()

    if (count > 0) {
      return (
        <div className='people-count-inner'>
          <div className='people-counter'>{this.getSum()}</div> personne
          {this.getSum() > 1 && 's'} {this.getSum() > 1 ? 'ont' : 'a'} répondu à
          cette question
        </div>
      )
    } else {
      return <div>Personne n'a encore répondu à cette question</div>
    }
  }

  render() {
    return (
      <div className='result'>
        <div className='header'>
          <h2>{this.props.title}</h2>
          <div className='people-count'>{this.getPeopleCount()}</div>
        </div>
        <div className='answers'>
          {this.props.answers.map((answer, index) => {
            if (this.getPct(index) > 0)
              return (
                <div
                  className={
                    'answer-line' +
                    (this.props.userAnswer === index ? ' user-answer' : '')
                  }
                  key={'result-answer-' + index}
                >
                  <div className='answer-text'>
                    {!this.props.gifs ? (
                      <div dangerouslySetInnerHTML={{ __html: answer }} />
                    ) : (
                      <img
                        alt={answer}
                        style={{ width: '65%', height: 'auto' }}
                        src={this.props.gifs[index]}
                      />
                    )}
                  </div>
                  <div className='answer-bar'>
                    <div
                      style={{
                        display: 'inline-block',
                        height: '10px',
                        width: this.getPct(index) + '%',
                        background: '#ad427f'
                      }}
                    />
                    <div className='pct-label'>
                      {Math.round(this.getPct(index))} %
                    </div>
                  </div>
                  {/* <div>{this.props.count ? (this.props.count[index] ? this.props.count[index].count : 0) : 0}</div> */}
                </div>
              )
          }, this)}
        </div>
        {/* <div className="question-number">{this.props.id + 1} / {this.props.questionMax}</div> */}
      </div>
    )
  }
}
